import { render } from "./ForumDetailPanel.vue?vue&type=template&id=59cc3482"
import script from "./ForumDetailPanel.vue?vue&type=script&lang=js"
export * from "./ForumDetailPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__